import { Injectable } from '@angular/core';
import { BaseService } from '../_shared/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { S3Service } from './s3.service';
import { getUrl } from '../_shared/utils';
import { JWTTokenService } from './jwtToken.service';
import { map, mergeMap } from 'rxjs/operators';

@Injectable()
export class SoundEffectService extends BaseService {

  public uploadSoundEffect(mp3File: File): Observable<any> {
    this.RemoveFromCache('assets/sound-effect');
    return this.httpClient.post<any>(getUrl('assets/sound-effect'), { name: mp3File.name }, this.buildOptions(true))
      .pipe(mergeMap(resp => {

        return this.s3service.uploadFile(mp3File, resp.folder.toLowerCase().replace(/ /g, '-'), "get-signed-s3-url").pipe(map(_ => {
          return resp;
        }));
      }));
  }

  public getSoundEffects(): Observable<SoundEffect[]> {
    return this.CachedHttpGet<SoundEffect[]>('assets/sound-effect');
  }

  public deleteSoundEffect (effectId: number) : Observable<any> {

    return this.httpClient.delete<any>(getUrl(`assets/sound-effect/delete/${effectId}`), this.buildOptions(true))
  }

  constructor(httpClient: HttpClient, private s3service: S3Service, jwtTokenService: JWTTokenService) {
    super(httpClient, jwtTokenService);
  }
}

export interface SoundEffect {
  soundEffectId: number;
  title: string;
  url: string;
}
